import React from 'react';
import {Box, FormControlLabel, Radio, RadioGroup, TextField, Typography} from '@mui/material';
import {alpha} from '@mui/material/styles';
import {useDispatch, useSelector} from 'react-redux';
import {campaignFormActions as actions} from '../../store/actions/campaignFormAction';
import ConditionTabs from '../campaigns/conditions/ConditionTabs';
import {getSettingsColors} from '../settings/SettingsDesign';

export default function FlowConditions({nameError}) {
    const {flow, selectedRuleNumber} = useSelector(state => state.campaignForm);
    const dispatch = useDispatch();
    const rule = flow.rules[selectedRuleNumber];
    return <Box className="flow-conditions" sx={{display: 'grid', gap: 2, minWidth: 0}}>
        <TextField value={rule.name} label="Rule name *" fullWidth size="small" error={!!nameError} helperText={nameError}
            slotProps={{inputLabel: {shrink: true}, htmlInput: {'data-flow-field': `rules.${selectedRuleNumber}.name`}}}
            onChange={event => dispatch(actions.updateRuleName(selectedRuleNumber, event.target.value))}/>
        <Box>
            <Typography sx={{fontSize: 13, fontWeight: 600, mb: 0.5}}>Match conditions</Typography>
            <RadioGroup row value={rule.logicalRelation || 'and'} aria-label="Match conditions" onChange={event => dispatch(actions.updateLogicalRelation(selectedRuleNumber, event.target.value))}
                sx={{width: 'fit-content', maxWidth: '100%', px: 1, py: 0.5, gap: {xs: 0, sm: 1}, flexDirection: {xs: 'column', sm: 'row'},
                    bgcolor: theme => getSettingsColors(theme).inset, borderRadius: '8px',
                    '& .MuiFormControlLabel-root': {m: 0}, '& .MuiFormControlLabel-label': {fontSize: 13}, '& .MuiRadio-root': {p: 0.75}}}>
                <FormControlLabel value="and" control={<Radio size="small"/>} label="All conditions (AND)"/>
                <FormControlLabel value="or" control={<Radio size="small"/>} label="Any condition (OR)"/>
            </RadioGroup>
        </Box>
        <Box sx={{minWidth: 0,
            '& > .MuiBox-root, & .MuiAppBar-root': {bgcolor: 'transparent'},
            '& .MuiTabs-root': {bgcolor: theme => getSettingsColors(theme).inset, borderRadius: '10px', minHeight: 42, p: 0.5},
            '& .MuiTabs-list': {gap: 0.5},
            '& .MuiTabs-indicator': {display: 'none'},
            '& .MuiTab-root': {fontSize: 13, minHeight: 38, minWidth: 80, width: 'auto', px: 1.5, py: 1, borderRadius: '7px', textTransform: 'none',
                color: 'text.secondary',
                '&:hover': {bgcolor: theme => alpha(theme.palette.primary.main, 0.08), color: 'primary.main'},
                '&.Mui-focusVisible': {outline: '2px solid', outlineColor: 'primary.main', outlineOffset: -2},
                '&.Mui-selected': {bgcolor: theme => theme.palette.mode === 'light' ? getSettingsColors(theme).card : getSettingsColors(theme).input, color: 'primary.main', fontWeight: 600}},
            '& [role="tabpanel"] > .MuiBox-root': {display: 'grid', gap: 0.75},
            '& [role="tabpanel"] > .MuiBox-root > .MuiBox-root, & [role="tabpanel"] > .MuiBox-root > div:not(.MuiBox-root) > .MuiBox-root': {
                bgcolor: theme => getSettingsColors(theme).inset, borderRadius: '8px', px: 1.5, py: 1.5, m: 0, minWidth: 0, gap: 0.5,
                '& > .MuiBox-root:first-child': {alignItems: 'center', mb: 0,
                    '& > .MuiBox-root:first-child': {pt: 0, fontSize: 13}}
            },
            '& [role="tabpanel"] .MuiRadio-root, & [role="tabpanel"] .MuiCheckbox-root': {p: 0.75},
            '& [role="tabpanel"] .MuiButton-root[title="Add condition"]': theme => theme.palette.mode === 'light' ? {
                bgcolor: getSettingsColors(theme).card, border: '1px solid', borderColor: alpha(theme.palette.primary.main, 0.25),
                whiteSpace: 'nowrap',
                '&:hover': {bgcolor: alpha(theme.palette.primary.main, 0.08), borderColor: 'primary.main'},
                '&.Mui-focusVisible': {outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2}
            } : {},
            '& .MuiFormControlLabel-label': {fontSize: 12},
            '& .MuiFormControlLabel-root': {mr: 1.5},
            '& .MuiAutocomplete-root': {minWidth: 0, maxWidth: '100%'},
            '& .MuiInputBase-root': {minWidth: 0},
            '& .MuiChip-root': {maxWidth: '100%'}
        }}><ConditionTabs/></Box>
    </Box>;
}
